<template>
  <div class="flex flex-col gap-y-[24px] bg-surface-primary p-[16px] rounded-[8px]">
    <div class="text-v-ui-gray-900 text-[20px] font-semibold leading-[120%]">
      Дополнительные сведения
    </div>

     <!-- Form item -->
     <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Участвует в нозологии артериального давления
      </div>
      <div class="massive-16-reg text-secondary">{{ kzsData.subType === 1 ? 'Да' : 'Нет' }}</div>
      <VDescription
        type="ghost"
        deviceType="desktop"
        text="КЗС рассчитывается по комбинации индикаторов САД и ДАД"
        v-if="kzsData.subType === 1"
      />

      <VDescription
        type="ghost"
        deviceType="desktop"
        text="КЗС рассчитывается отдельно для каждого индикатора"
        v-else
      />
    </div>

    <div class="flex flex-col gap-y-[8px]">
      <div class="flex gap-x-[2px] text-heading-primary title-16-medium-500">
        Дата и время создания
      </div>
      <div class="massive-16-reg text-secondary">{{ formattedCreationDate }}</div>
    </div>
  </div>
</template>

<script>
import { VDescription } from '@gostelemed.front/rt-doctis.designsystem';
import {format} from "date-fns"
import { ru } from "date-fns/locale/ru";

export default {
  name: 'KzsViewAdditionalSettings',
  components: {
    VDescription
  },
  props: {
   kzsData: {
    type: Object,
    required: true,
   },
  },

  computed: {
    formattedCreationDate() {
      return this.kzsData.createdAt ? format(new Date(this.kzsData.createdAt), 'dd.MM.yyyy HH:mm', { locale: ru }) : 'Неизвестно';
    },
  },
}
</script>
